import React from "react";
import "./AvailabilityPage.css"
import Navbar from "../navbar/Navbar";
import Booking1 from "../booking/Booking1";

const AvailabilityPage=()=>{
    return(
        <div className="">
<Navbar/>
<Booking1/>
        </div>
    )
}

export default AvailabilityPage